<template>
  <v-row justify="center">
    <v-dialog v-model='dateorderlistmodal' max-width="950" height="500">
      <v-card>
        <v-toolbar height="73" color="white" class="headlinestyle">
          <v-btn icon @click="dateorderlistmodal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title><strong>{{title}}{{ currentdate }}</strong></v-toolbar-title>
        </v-toolbar>

        <!-- table orderlist -->
        <div v-if="!orderid">
          <v-layout justify-center>
            <v-flex xs12 sm12 md12 lg12>
              <v-data-table
                :headers="orderheaders"
                :items="orderlist"
                hide-default-footer
                class="elevation-1"
              >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td @click="orderdetail(item._id)">{{ item.order_no }}</td>
                  <td @click="orderdetail(item._id)">{{ item.username }}</td>
                  <td @click="orderdetail(item._id)">{{ item.name }}</td>
                  <td @click="orderdetail(item._id)">{{ item.adminref_name }}</td>
                  <td @click="orderdetail(item._id)">
                    <v-chip
                      :color="getColor(item.order_status)"
                      text-color="white"
                      @click="orderdetail(item._id)"
                    >{{ item.order_status_th }}
                    </v-chip>
                  </td>
                  </tr>
                </tbody>
          </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>

        <!-- View Detail mode -->
        <div v-if="orderid">
        <br />
        <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class='ml-10'><p align="right"><strong>Order No : &nbsp;</strong></p></div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div><p>{{ orderdatas.order_no }}</p></div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class='ml-10'><p align="right"><strong>Customer : &nbsp;</strong></p></div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div><p>{{ orderdatas.username }}</p></div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class='ml-10'><p align="right"><strong>ชื่อ : &nbsp;</strong></p></div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div><p>{{ orderdatas.name }}</p></div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class='ml-10'><p  align="right"><strong>ที่อยู่จัดส่ง : &nbsp;</strong></p></div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div><p>{{ orderdatas.address }}</p></div>
            </v-flex>
          </v-layout>
          <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class='ml-10'><p align="right"><strong>เบอร์โทร : &nbsp;</strong></p></div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div><p>{{ orderdatas.tel }}</p></div>
            </v-flex>
          </v-layout>
           <v-layout align-center>
            <v-flex xs12 sm3 md3 lg3>
              <div class='ml-10'><p align="right"><strong>วันที่สั่งซื้อ : &nbsp;</strong></p></div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div><p>{{ order_date_th }}</p></div>
            </v-flex>
          </v-layout>
           <v-layout align-start>
            <v-flex xs12 sm3 md3 lg3>
              <div class='ml-10'><p align="right"><strong>สถานะ : &nbsp;</strong></p></div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div><v-chip
                :color="getColor(orderdatas.order_status)"
                text-color="white"
              >{{ orderdatas.order_status_th }}
              </v-chip></div>
            </v-flex>
          </v-layout>
          <v-layout align-start>
            <v-flex xs12 sm3 md3 lg3>
              <div class='ml-10'><p align="right"><strong>การชำระเงิน : &nbsp;</strong></p></div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div><v-chip
                :color="getColor(orderdatas.payment_status)"
                outlined
              >{{ orderdatas.payment_status_th }}
              </v-chip></div>
            </v-flex>
          </v-layout>
          <v-layout align-center v-if="delivery_date_th">
            <v-flex xs12 sm3 md3 lg3>
              <div class='ml-10'><p align="right"><strong>วันที่จัดส่ง : &nbsp;</strong></p></div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div><p>{{ delivery_date_th }}</p></div>
            </v-flex>
          </v-layout>
          <v-layout align-center v-if="delivered_date_th">
            <v-flex xs12 sm3 md3 lg3>
              <div class='ml-10'><p align="right"><strong>วันที่จัดส่งเสร็จสิ้น : &nbsp;</strong></p></div>
            </v-flex>
            <v-flex xs12 sm8 md8 lg8>
              <div><p>{{ delivered_date_th }}</p></div>
            </v-flex>
          </v-layout>
          <br />
          <div class='ml-10'><p align="center"><strong>รายการสินค้า</strong></p></div>
        <v-container>
          <v-layout justify-center>
            <v-flex xs10 sm10 md10 lg10>
              <v-data-table
                :headers="headers"
                :items="productitems"
                hide-default-footer
                class="elevation-2"
                item-key="_id"
                disable-pagination
              >
              <template v-slot:item.image_url="{ item }">
                <v-container v-if="item.image_url">
                <v-img
                  class="white--text align-center"
                  style="height:60px; width:90px;"
                  :src="item.image_url"
                ></v-img>
                </v-container>
              </template>
              <template v-slot:body.append>
                <br />
                <tr>
                  <td />
                  <td />
                  <td />
                  <td />
                  <td><div><p align="right"><strong>รวม </strong><small style='color: black;'>(ราคาไม่รวมภาษี)</small></p></div></td>
                  <td>
                    <p align="left" style="color: red;">{{ amount }}&nbsp;&nbsp;&nbsp;บาท</p>
                  </td>
                </tr>
              </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
        <br />
        <v-layout justify-center v-if="paymentconfirm_image !== ''">
        <div class='ml-10'><p align="center"><strong>หลักฐานการชำระเงิน</strong></p></div>
        </v-layout>
        <v-layout justify-center v-if="paymentconfirm_image !== ''">
          <div>
            <expandable-image
              class="ml-10 image"
              :src="paymentconfirm_image"
              :close-on-background-click="true"
            />
          </div>
        </v-layout>
        <v-card-actions>
          <div class="flex-grow-1"></div>
            <v-btn color="pink" style="margin-right: 5px" outlined @click="back()">กลับ</v-btn>
        </v-card-actions>
        </div>
        <br />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ExpandableImage from './ExpandableImage'
import { sync } from 'vuex-pathify'
// import axios from 'axios'
import moment from 'moment'
import numeral from 'numeral'
moment.locale('th')
export default {
  components: {
    ExpandableImage
  },
  data () {
    return {
      title: 'รายการส่งสินค้า วันที่ ',
      headers: [
        { text: 'รหัสซื้อขาย', align: 'center', sortable: false, value: 'product_no' },
        { text: 'รูปสินค้า', align: 'center', sortable: false, value: 'image_url' },
        { text: 'ชื่อสินค้า', align: 'center', sortable: false, value: 'name' },
        { text: 'ราคา', align: 'center', sortable: false, value: 'price' },
        { text: 'จำนวน', align: 'center', sortable: false, value: 'quantity' },
        { text: 'ประเภท', align: 'center', sortable: false, value: 'type' }
      ],
      orderdatas: '',
      currentdate: '',
      productitems: [],
      name: '',
      address: '',
      tel: '',
      order_status: '',
      order_date_th: '',
      delivery_date_th: '',
      delivered_date_th: '',
      amount: 0,
      paymentconfirm_image: '',
      orderheaders: [
        { text: 'เลขที่เอกสาร', align: 'center', sortable: false, value: 'order_no' },
        { text: 'รหัสร้านค้า', align: 'center', sortable: false, value: 'username' },
        { text: 'ชื่อ-สกุล', align: 'center', sortable: false, value: 'name' },
        { text: 'เจ้าหน้าที่ผู้ดูแล', align: 'center', sortable: false, value: 'adminref_name' },
        { text: 'สถานะ', align: 'center', sortable: false, value: 'order_status_th' }
      ],
      orderid: '',
      orderdata: '',
      orderlist: []
    }
  },
  methods: {
    getColor (status) {
      if (status === '00') return 'info'
      else if (status === '01') return 'success'
      else if (status === '02') return '#DD4B39'
      else if (status === '10') return '#52B9EB'
      else if (status === '11') return '#F7BA38'
      else if (status === '12') return '#388E3C'
      else if (status === '13') return '#F23B22'
      else if (status === '0') return 'info'
      else if (status === '1') return 'warning'
      else if (status === '2') return 'success'
      else if (status === '3') return '#DD4B39'
      else if (status === '4') return '#000000'
    },
    back () {
      this.orderid = ''
    },
    orderdetail (id) {
      let order = this.orderlist.find(od => od._id === id)
      this.orderid = id
      this.orderdatas = order
      this.delivery_date = order.delivery_date ? order.delivery_date.split('T')[0] : ''
      this.delivered_date = order.delivered_date ? order.delivered_date.split('T')[0] : ''
      this.order_date_th = moment(order.order_date).format('LL')
      this.productitems = (order.productitems).map(pd => {
        pd.price = numeral(pd.price).format('0,0.00')
        return { ...pd, image_url: pd.image ? `${process.env.VUE_APP_API}${pd.image}` : '' }
      })
      this.amount = numeral(order.productitems ? order.productitems.reduce((sum, product) => {
        return sum + (Number(product.price) * Number(product.quantity))
      }, 0) : 0).format('0,0.00')
    }
  },
  computed: {
    dateorderlistmodal: sync('dateorderlistmodal'),
    currentorderlist: sync('currentorderlist'),
    currentorderlistmode: sync('currentorderlistmode')
  },
  watch: {
    currentorderlist () {
      if (this.currentorderlist !== '') {
        this.orderdatas = JSON.parse(this.currentorderlist)
        this.currentdate = moment(this.orderdatas.date).format('LL')
        this.orderlist = this.orderdatas.orderitems
      }
      this.orderid = ''
    }
  },
  created () {
  }
}
</script>
<style>
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
  text-align: center;
}
.v-chip {
  font-family: 'Kanit';
}
.v-btn {
  font-family: 'Kanit';
  font-weight: bold;
}
.v-data-table {
  font-family: 'Kanit';
}
.v-list-item {
  font-family: 'Kanit';
}
</style>

<style scoped>
.image {
  position: relative;
  width: 200px;
  max-width: 100%;
}
</style>

<style scoped>
td {
  max-width: 90px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
</style>
